import BulkPickup from './BulkPickup';

export default BulkPickup;
